import axios from 'axios';
import type { Coordinates, HydroAnalysisResult, WatershedData } from '../types';

// In production (base=/demo/hydro/), API is at /demo/hydro/api
// In development (base=/), API is at /api (proxied by Vite)
const apiBaseURL = import.meta.env.PROD ? '/demo/hydro/api' : '/api';

const api = axios.create({
  baseURL: apiBaseURL,
  timeout: 60000, // Watershed delineation can take time
});

export async function analyzePoint(point: Coordinates): Promise<HydroAnalysisResult> {
  const response = await api.post<HydroAnalysisResult>('/analyze', {
    lng: point.lng,
    lat: point.lat,
  });
  return response.data;
}

export async function delineateWatershed(point: Coordinates): Promise<WatershedData> {
  const response = await api.post<WatershedData>('/watershed/delineate', {
    lng: point.lng,
    lat: point.lat,
  });
  return response.data;
}

export async function getPeakFlows(
  point: Coordinates,
  drainageAreaSqMi?: number
): Promise<HydroAnalysisResult['peak_flows']> {
  const response = await api.get('/peak-flows', {
    params: {
      lng: point.lng,
      lat: point.lat,
      area_sq_mi: drainageAreaSqMi,
    },
  });
  return response.data;
}

export async function getPrecipFrequency(
  point: Coordinates
): Promise<HydroAnalysisResult['precip_frequency']> {
  const response = await api.get('/precip-frequency', {
    params: {
      lng: point.lng,
      lat: point.lat,
    },
  });
  return response.data;
}

export async function getSoilData(
  point: Coordinates
): Promise<HydroAnalysisResult['soil']> {
  const response = await api.get('/soil', {
    params: {
      lng: point.lng,
      lat: point.lat,
    },
  });
  return response.data;
}
